export default "__VITE_ASSET__CRacVtRZ__"